<script>
    import { mapState } from 'vuex';

    export default {
        inheritAttrs: false,
        computed: {
            ...mapState('wizard', ['currentSubStep', 'useEnroleeBillingAddress', 'isMinor', 'parentalAuthorization', 'showLegalGuardian1', 'showLegalGuardian2', 'showApprenticeshipSupervisor', 'numberOfOptionalDocuments', 'uploadDocuments', 'uploadLegalGuardianForm']),
            slotProps() {
                return {
                    currentSubStep: this.currentSubStep,
                    useEnroleeBillingAddress: this.useEnroleeBillingAddress,
                    isMinor: this.isMinor,
                    parentalAuthorization: this.parentalAuthorization,
                    showLegalGuardian1: this.showLegalGuardian1,
                    showLegalGuardian2: this.showLegalGuardian2,
                    showApprenticeshipSupervisor: this.showApprenticeshipSupervisor,
                    numberOfOptionalDocuments: this.numberOfOptionalDocuments,
                    uploadDocuments: this.uploadDocuments,
                    uploadLegalGuardianForm: this.uploadLegalGuardianForm,
                };
            },
        },
        render() {
            return this.$scopedSlots.default(this.slotProps);
        },
    };
</script>
